module.exports = __webpack_public_path__ + "static/img/logo_competences.384019d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_competences.png
// module id = E5XQ
// module chunks = 1